import React from 'react';
import { IconProps } from '.';

const SvgNumTwoFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill={secondaryColor}
        d='M8.673 16.445h6.745V14.83h-4.023v-.052l1.432-1.393c1.94-1.758 2.46-2.637 2.46-3.711 0-1.634-1.34-2.787-3.359-2.787-1.985 0-3.352 1.179-3.346 3.021h1.862c-.007-.905.573-1.465 1.458-1.458.866-.007 1.498.514 1.498 1.354 0 .749-.476 1.27-1.354 2.11L8.66 15.024l.013 1.42Z'
      />
    </svg>
  );
};

export default SvgNumTwoFill;
